
import React from "react";
import p1 from "../../assets/Images/P1.png";
import p2 from "../../assets/Images/P2.png";
import lad from "../../assets/Images/11.png";
import snow from "../../assets/Images/12.png";

const Glimpse = () => {
  return (
    <div className="text-center pt-5">
      <div className="container-fluid px-0"> 
        <div className="row g-0"> 
          {[p1, p2, lad, snow].map((img, index) => (
            <div key={index} className="col-lg-3 col-md-6 col-sm-12">
              <img
                src={img}
                alt={`p${index + 1}`}
                style={{
                  width: "100%",
                  height: "300px",
                  objectFit: "cover",
                  // borderRadius: "10px" // Set to 0 for seamless edge-to-edge look
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Glimpse;
